/* eslint-disable @typescript-eslint/no-require-imports */
import CustomPlatform from "$src/core/utils/platform/platform";

import type { SessionStorageService } from "./types";

export default CustomPlatform.select<() => SessionStorageService>({
  web: () => require("./session-storage.web").default,
  default: () => require("./session-storage").default,
})();
